(function () {

  angular
    .module('meanApp')
    .controller('recipeCardCtrl', recipeCardCtrl);

  	recipeCardCtrl.$inject = ['$scope', '$location','authentication', 'loginModal', 'User', '$rootScope', 'usersManager', '$state'];
  	function recipeCardCtrl($scope, $location, authentication, loginModal,  User, $rootScope, usersManager, $state) {
		var vm = this,
        DEFAUlT_INITIAL_HEIGHT = 110,
        INGREDIENTS_COLORS = ['#F49AC2', '#CB99C9', '#C23B22', '#FFD1DC', '#DEA5A4', '#AEC6CF', '#77DD77', '#B39EB5', '#FFB347', '#B19CD9', '#FF6961' ,'#03C03C', '#FDFD96', '#779ECB', '#966FD6'];
	     //(in pixels)
        vm.sharePossible = navigator && navigator.share; //later modify and put a real condition on browser
		vm.goToRecipe = function(recipe, hash) {
	        if(hash) {
	            $state.go('recipe', {
	                id: recipe.slug,
	                '#': hash
	            });
	        }
	        else {
	            $state.go('recipe', {
	                id: recipe.slug
	            });
	        }
          };
          
        vm.onShare = function(recipe) {
            if (vm.sharePossible) {
                navigator.share({
                    title: recipe.title,
                    url : document.URL,
                    text: "Regarde, j'ai trouvé cette recette sur Fraiseoubacon.com :)"
                });
            }
        };


	    /**below function to go back to previous mode ***/
	    vm.goBackToLandscapeMode = function(recipe) {
	        //step 0 hide the cross
	        recipe.isCrossHidden = true;
	        //step 1 retrieve the element
	        var finalContent = angular.element(document.querySelector('#'+recipe.slug +' .final-content'))[0];
	        //step 2 reset its natural height
	        finalContent.style.height= finalContent.offsetHeight+'px';
	        recipe.offsetHeight = finalContent.offsetHeight;

	        setTimeout(function() {
	            //step 3 make it decrease to 0
	            finalContent.style.height = DEFAUlT_INITIAL_HEIGHT +'px';
	            setTimeout(function() {
	                //step 4 do the hide and show process
	                recipe.isFolded = true;
	                recipe.isCrossHidden = false;
	                $scope.$apply();
	            }, 2001);
	        }, 50);
	    };

	    vm.goToEditRecipe = function(recipe) {
	      	$state.go('recipecreationstep', {
	        	id: recipe.slug,
	        	step: '1'
	      	});
        };

        vm.goToAuthorPage = function(recipe) {
            $state.go('profile.info', {
                id: recipe.author._id
            });
        };


	    vm.goToInstructions = function(recipe) {
	    	$state.go('recipeInstructions', {
	    		id: recipe.slug
	    	});
        };
        
        vm.activateNumbers = function(cssSelector) {
            //1- find all the data-odometer-value
            var value, od;
            document.querySelectorAll('.nutrition-fact-quantity'+cssSelector).forEach(function(nodeEl) {
                value = nodeEl.getAttribute('data-odometer-value');
                if (Odometer) {
                    od = new Odometer({
                          el: nodeEl,
                          value: 0,
                          format: '( ddd),d',
                          theme: 'default'
                    });
                    od.update(value);
                }
            });
        };

        vm.getColor = function(ingredientName) {
        	var nbColors = INGREDIENTS_COLORS.length,
        	toBeReturned = INGREDIENTS_COLORS[0],
        	firstLetter = parseInt(ingredientName.charAt(0), 36) - 9;
        	if (ingredientName.length > 1) {
        		var secondLetter = parseInt(ingredientName.charAt(1), 36) - 9,
        		average = (firstLetter + secondLetter)/2,
        		ratio = average/26; //26 is the number of letters in occidental alphabet
				toBeReturned = INGREDIENTS_COLORS[Math.trunc(ratio*nbColors)];
        	}
        	else {
        		toBeReturned = INGREDIENTS_COLORS[Math.trunc((firstLetter/26)*nbColors)];
        	}
        	console.log(toBeReturned);
        	return toBeReturned;
        };

        //THe following code is duplicated in recipe.read.controller, that should be factorized....
        vm.onLikeRecipe = function(recipe) {
            if (recipe.interactions.isLiked ) {
                recipe.unlike();
                recipe.interactions.likeCount --;
            }
            else {
                recipe.like();
                recipe.interactions.likeCount ++;
            }

            //increase counter as well
            recipe.interactions.isLiked = !recipe.interactions.isLiked;
            
        };
    
        vm.onBookmarkRecipe = function(recipe) {
            if (recipe.interactions.isBookmarked) {
                recipe.unbookmark();
                recipe.interactions.bookmarkCount --;
            }
            else {
                recipe.bookmark();
                recipe.interactions.bookmarkCount ++;
            }
            recipe.interactions.isBookmarked = !recipe.interactions.isBookmarked;
        };
	}
})();